jQuery(document).ready(function ($) {
  isSmallMobile = {
    any: function () {
      return $(window).width() < 767;
    },
  };

  if (document.body.classList.contains("home")) {
    // start 01413186
    $('.home a.button.outline-button.mobileUsedBtn').insertBefore('.home #mobile-advanced-search .buttonRow .flex-container a:nth-child(1)');
    // end 01413186
    // *************************************************************************************************
    //	Model Row
    // *************************************************************************************************

    // var owl1 = jQuery(".carousel-wrapper").owlCarousel({
    //   navigation: true,
    //   items: 3,
    //   dots: true,
    //   pagination: false,
    //   navigationText: [
    //     "<i class='fa fa-chevron-left'> </i>",
    //     "<i class='fa fa-chevron-right'> </i>",
    //   ],
    //   itemsDesktop: [1199, 3],
    //   itemsDesktopSmall: [979, 2],
    //   itemsTablet: [632, 1],
    //   itemsMobile: [320, 1],
    //   beforeMove: function () {
    //     // lazyload hidden owl carousel items when they come into view
    //     if (typeof LazyLoad === "function") {
    //       var myLazyLoad = new LazyLoad();
    //     }
    //   },
    // });

    var models_slider = new Swiper('#modelRow .swiper-container', {
			speed: 300,
			slidesPerGroup: 1,
			slidesPerView: 3,
			// spaceBetween: 55, // This should match the ".swiper-container" left/right padding on tablet+ in the stylesheet (to allow space for the arrows)
			preloadImages: false,
			navigation: {
				nextEl: '#modelRow .swiper-button-next.model',
				prevEl: '#modelRow .swiper-button-prev.model'
			},
			breakpoints: {
				1024: {
					slidesPerGroup: 1,
					slidesPerView: 3
				},
				767: {
					slidesPerGroup: 1,
					slidesPerView: 1
				},
			},
		});

// ***************************************************
// This is only needed for infiniti/base/section-models-v2 
// ***************************************************
$('a[data-toggle="tab"]').on('shown.bs.tab', function(e) {
			var index = $(this).parent().index();
			if (models_slider && models_slider[index]) {
				models_slider[index].update();
				models_slider[index].navigation.update();
			}
		});
    
    // *************************************************************************************************
    //	Review Row
    // *************************************************************************************************

    // var owl2 = $("#reviewCarousel").owlCarousel({
    //   autoPlay: 7000,
    //   navigation: true,
    //   navigationText: [
    //     '<i class="fa fa-angle-left"></i>',
    //     '<i class="fa fa-angle-right"></i>',
    //   ],
    //   items: 3,
    //   itemsDesktop: [1024, 2],
    //   itemsDesktopSmall: [979, 1],
    //   itemsTablet: [768, 1],
    //   // Notice the added comma in the previous line and
    //   // the added function below
    //   beforeMove: function () {
    //     if (typeof LazyLoad === "function") {
    //       var myLazyLoad = new LazyLoad();
    //     }
    //   },
    // });

    var reviews = new Swiper('#reviewsRow .swiper-container', {
      speed: 300,
      slidesPerGroup: 3,
      slidesPerView: 3,
      spaceBetween: 40,
      watchOverflow: true,
      lazy: {
          enabled: true,
      },
      navigation : {
          nextEl : '#reviewsRow .swiper-button-next.reviews',
          prevEl : '#reviewsRow .swiper-button-prev.reviews'
      },
      breakpoints: {
          1199: {
              slidesPerGroup: 2,
              slidesPerView: 2
          },
          979: {
              slidesPerGroup: 1,
              slidesPerView: 1
          },
      },
  });

    // START - DI Slider Inventory Selects
    if ($(window).width() > 767) {
      setTimeout(function () {
        $(".search-fields select").selectpicker({ dropupAuto: false });
        $("body").live("search_filters_rendered", function () {
          $(".search-fields select").selectpicker("refresh");
        });
      }, 200);
    }
    // END - DI Slider Inventory Selects
  }

  $("span.parts-phone").insertAfter(".header-top-tool.new-phone");

  if ($(window).width() < 1025) {
    $("ul.nav > li > ul > li.menu-item-has-children > a").append(
      '<span class="caret"></span>'
    );
    $("ul.nav > li > ul > li.menu-item-has-children > a").click(function (e) {
      if ($(this).next("ul").is(":visible") == false) {
        $(this).next("ul").show();
      } else {
        $(this).next("ul").hide();
      }
      return false;
    });
  }

  if ($("div.countdown-timer.row")[0]) {
    $("body").addClass("count-timer-active");
  }

  $(
    "<img class='carfax-social' src=/wp-content/themes/DealerInspireDealerTheme/images/carfax-2021.png />"
  ).insertAfter("#prefooter .social");
});
